import { useState, useEffect } from "react"
import magnifyingGlassIllustration from "images/web/empty_states/person_with_magnifying_glass.svg"
import emtpyBox from "images/web/empty_states/empty_box.svg"

import "./empty_state.scss"
import breakpoints from "foundation/_responsive_export.scss?variables"

interface Props {
  heading: string
  copy: string
  cta: string | null
  ctaUrl: string | null
  clickTracking: object | null
  illustration: string | null
}

const EmptyStateCta = ({
  heading,
  copy,
  cta,
  ctaUrl,
  clickTracking,
  illustration = "mag",
}: Props) => {
  const widthMatcher = window.matchMedia?.(`(max-width: ${breakpoints.screenXsMax})`)
  const [isMobile, setMobile] = useState(widthMatcher?.matches)


  useEffect(() => {
    const widthListener = (event: { matches: any }) => setMobile(event.matches)
    widthMatcher?.addEventListener("change", widthListener)

    return () => {
      widthMatcher?.removeEventListener("change", widthListener)
    }
  }, [])

  return (
    <div styleName="empty-state-container">
      <div
        styleName="illustration"
        dangerouslySetInnerHTML={{
          __html: illustration === "mag" ? magnifyingGlassIllustration : emtpyBox,
        }}
      />
      <h4>{heading}</h4>
      <p className="txt-body-3">{copy}</p>
      {cta && ctaUrl && (
        <a
          href={ctaUrl}
          className={isMobile ? "button-tertiary" : "button-secondary"}
          data-track-ifttt-next-event="click"
          data-track-data={JSON.stringify(clickTracking)}
        >
          {cta}
        </a>
      )}
    </div>
  )
}

export default EmptyStateCta
